import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {Dropdown} from '@components/common/dropdown/dropdown'

const TwIconButton = tw.div`
  group/image-menu
  cursor-pointer
  relative
  w-24
  h-24
  flex
  items-center
  justify-center
  isolate
`

const TwIconButtonBg = tw.div<{$active?: boolean}>`
  -z-10
  absolute
  top-0
  bottom-0
  left-0
  right-0
  rounded-full
  bg-secondary

  group-hover/image-menu:bg-action-default
`

// todo: extract to `base/menu`
const TwMenu = tw.div`
  py-4
  rounded-4
  bg-grey-l100
  border-solid
  border-1
  border-grey-l60
`

const TwMenuItem = tw.div`
  cursor-pointer
  h-32
  px-12
  flex
  items-center
  gap-8
  hover:bg-interactive-l100
`

const TwMenuItemText = tw.div`
  whitespace-nowrap
  plain-text-regular
  text-primary
`

interface Props {
  url: string
  onSetBackground?: (url: string, e: React.MouseEvent) => void
  onRemoveBackground?: (e: React.MouseEvent) => void
  onDownloadFile?: (url: string, e: React.MouseEvent) => void
  className?: string
  active: boolean
  setActive: (visible: boolean) => void
  reference: HTMLElement
}

export const ImageMenuIcon = () => {
  return (
    <TwIconButton>
      <Icon icon="IconDotsVertical" color="invert" size={16} />
      <TwIconButtonBg className="message-image-bg" />
    </TwIconButton>
  )
}

export const ImageMenuDropdown = ({
  url,
  onSetBackground,
  onRemoveBackground,
  onDownloadFile,
  active,
  setActive,
  reference
}: Props) => {
  return (
    <Dropdown
      hideArrow
      reference={reference}
      visible={active}
      onVisibleChange={() => setActive(false)}
      placement="bottom-start"
      fallbackPlacements={['bottom-end', 'left-start']}
      content={
        // todo: refactor this later to `base/menu` w/o check marks on menu item
        <TwMenu>
          {onSetBackground && (
            <TwMenuItem
              onClick={e => {
                setActive(false)
                onSetBackground(url, e)
              }}
            >
              <Icon icon="IconPhoto" color="secondary" />
              <TwMenuItemText>{Lang.msg.setTaskImage}</TwMenuItemText>
            </TwMenuItem>
          )}
          {onDownloadFile && (
            <TwMenuItem
              onClick={e => {
                setActive(false)
                onDownloadFile(url, e)
              }}
            >
              <Icon icon="IconDownload" color="secondary" />
              <TwMenuItemText>{Lang.msg.download}</TwMenuItemText>
            </TwMenuItem>
          )}
          {onRemoveBackground && (
            <TwMenuItem
              onClick={e => {
                setActive(false)
                onRemoveBackground(e)
              }}
            >
              <Icon icon="IconDownload" color="secondary" />
              <TwMenuItemText>{Lang.msg.removeCurrentTaskImage}</TwMenuItemText>
            </TwMenuItem>
          )}
        </TwMenu>
      }
    />
  )
}
